<template>
    <div>
        <payman-filter :action="filterAction" ></payman-filter>
        <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
import columns from './../datatable/columns'
import { ApiUrl } from '@/common/api.service'
import { AuthorizationHeader } from '@/common/jwt.service'
import actionsColumn from './actions-column'
import paymanFilter from './payman-filter'

export default {

    components: {
        'payman-filter': paymanFilter,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "payman_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('payman'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style>

</style>